import { render, staticRenderFns } from "./layer-add-update-version.vue?vue&type=template&id=6c0e9f73&scoped=true&"
import script from "./layer-add-update-version.vue?vue&type=script&lang=js&"
export * from "./layer-add-update-version.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0e9f73",
  null
  
)

export default component.exports